import { Input } from "./ui/input";

// Combobox con ricerca + digitazione libera (native datalist).
// L'utente può scegliere una delle opzioni oppure digitare un valore non in lista.
export const DOC_TIPI = [
  "Carta d'identità",
  "Passaporto",
  "Patente di guida",
  "Permesso di soggiorno",
  "Tessera sanitaria",
  "Codice fiscale",
];
export const DOC_RILASCIATO = [
  "Comune",
  "MCTC - Motorizzazione Civile",
  "Questura",
  "Prefettura",
  "Consolato",
  "Ministero degli Interni",
];

export const COLORI_VEICOLO = [
  "BIANCO", "NERO", "GRIGIO", "ARGENTO", "BLU", "AZZURRO", "ROSSO", "BORDEAUX", "VERDE",
  "GIALLO", "ARANCIONE", "MARRONE", "BEIGE", "ORO", "VIOLA", "ROSA",
];

export default function Combobox({ value, onChange, options = [], testId, placeholder, className = "", onBlur, noUppercase }) {
  const listId = `${testId || "combo"}-list`;
  return (
    <>
      <Input list={listId} value={value || ""} onChange={(e) => onChange(e.target.value)} onBlur={onBlur} noUppercase={noUppercase}
        data-testid={testId} placeholder={placeholder} autoComplete="off"
        className={`h-9 bg-slate-900/60 border-slate-700 ${className}`} />
      <datalist id={listId} data-testid={`${listId}-options`}>
        {options.map((o) => <option key={o} value={o} />)}
      </datalist>
    </>
  );
}
